import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // ✅ track loading

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const userId = localStorage.getItem('userId');
    const name = localStorage.getItem('userName');
    if (token && role && userId) {
      setUser({ role, userId, name });
    }
    setLoading(false); // ✅ done checking
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('auth/login', { email, password });

    // Ensure userId is stored as string for consistency
    const userIdStr = String(data.userId);

    localStorage.setItem('token', data.token);
    localStorage.setItem('role', data.role.toLowerCase());
    localStorage.setItem('userId', userIdStr);
    localStorage.setItem('userName', data.name || '');

    setUser({ role: data.role.toLowerCase(), userId: userIdStr, name: data.name });
    return data.role.toLowerCase();
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
